exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img[data-v-54f02f8c]{width:100%;height:auto;border:1px solid #ccc;padding:5px}p[data-v-54f02f8c]{text-align:justify}h2[data-v-54f02f8c]{padding-top:0;margin-bottom:0;font-size:30px}.divider-line[data-v-54f02f8c]{border-bottom:1px solid #ccc}.published-info[data-v-54f02f8c]{font-size:14px;color:#000;padding-left:10px}a h2[data-v-54f02f8c]:hover{color:#bf5700}.gallery-item[data-v-54f02f8c]{width:100%;height:100%;min-height:230px;display:inline-block;background-repeat:no-repeat;background-size:cover;background-position:top,50%}.image-border[data-v-54f02f8c]{border:1px solid #ccc;padding:5px!important;margin:10px 0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-54f02f8c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/News.vue
// module id = 191
// module chunks = 0